import { useState } from "react";
import { motion } from "framer-motion";
import { Flame, Lock, Loader2 } from "lucide-react";
import { login, setToken } from "@/lib/api";

export default function StudioLogin({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!password || loading) return;
    setLoading(true);
    setError("");
    try {
      const { token } = await login(password);
      setToken(token);
      onSuccess();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Accesso non riuscito. Riprova.");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-neutral-100 flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-sm"
        data-testid="studio-login"
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-sm bg-[#D92D20] flex items-center justify-center">
            <Flame size={20} className="text-white" />
          </div>
          <div>
            <p className="font-display font-extrabold text-xl leading-none tracking-tight">STUDIO</p>
            <p className="text-[0.65rem] uppercase tracking-[0.25em] text-neutral-500 mt-1">Massimiliano Pulla</p>
          </div>
        </div>

        <h1 className="text-2xl font-display font-bold mb-1">Area riservata</h1>
        <p className="text-sm text-neutral-500 mb-8">Inserisci la password per accedere allo Studio.</p>

        <form onSubmit={submit} className="space-y-4">
          <div className="relative">
            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-600" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              autoFocus
              data-testid="studio-login-password"
              className="w-full bg-[#141414] border border-[#262626] rounded-md pl-10 pr-4 py-3 text-sm outline-none focus:border-[#D92D20] transition-colors"
            />
          </div>

          {error && (
            <p data-testid="studio-login-error" className="text-sm text-[#F87171]">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading || !password}
            data-testid="studio-login-submit"
            className="w-full flex items-center justify-center gap-2 bg-[#D92D20] hover:bg-[#b81f14] disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-md py-3 text-sm transition-colors"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : null}
            {loading ? "Verifica…" : "Entra"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
